// extracted by mini-css-extract-plugin
export default {"headline":"MediaEventWrapper_headline__0sHWz","emptyContent":"MediaEventWrapper_emptyContent__TZHEj","houseBannerAd":"MediaEventWrapper_houseBannerAd__Ay3Kh"};